import { featurePillars } from '../lib/marketing';

export function FeaturesPage(): JSX.Element {
  return (
    <div className="space-y-12">
      <header className="space-y-4 text-center">
        <span className="badge-soft">Platform pillars</span>
        <h1 className="text-4xl font-semibold text-foreground">The curated toolkit for modern property teams</h1>
        <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
          InspectAI orchestrates your entire inspection journey with intentional, design-led workflows— so capturing,
          analysing, and sharing feels as elevated as the spaces you represent.
        </p>
      </header>

      <div className="grid gap-8 md:grid-cols-2">
        {featurePillars.map((pillar) => (
          <article key={pillar.title} className="glass-card flex h-full flex-col gap-4 p-6">
            <div>
              <h2 className="text-xl font-semibold text-foreground">{pillar.title}</h2>
              <p className="text-sm text-muted-foreground">{pillar.description}</p>
            </div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {pillar.bullets.map((bullet) => (
                <li key={bullet}>• {bullet}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      <section className="glass-card space-y-3 p-6 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">Roadmap highlights</h2>
        <p>
          Coming soon: saved views, keyboard shortcuts, export analytics, multi-language reporting, and visual
          QA for collaborative reviews. Enterprise customers can opt into SSO, data residency controls, and
          integrations (PropertyMe, Console Cloud, Google Drive) on request.
        </p>
      </section>
    </div>
  );
}
